export const fr: Record<string, string> = {
  // ── shared ──
  'inv.showDetails': 'Afficher les détails',
  'inv.noDescription': 'Aucune description disponible.',
  'inv.addTag': 'Ajouter une étiquette',
  'inv.tagPlaceholder': 'Étiquette...',
  'inv.noTags': 'Aucune étiquette',
  'inv.exportPdf': 'Exporter en PDF',

  // ── side-panel labels ──
  'inv.label.type': 'Type',
  'inv.label.function': 'Fonction',
  'inv.label.description': 'Description',
  'inv.label.nature': 'Nature',
  'inv.label.domainStakeholder': 'Domaine / Partie prenante',
  'inv.label.motivatedBy': 'Motivé par',
  'inv.label.motivatedFor': 'Motivé pour',
  'inv.label.tags': 'Étiquettes',

  // ── empty states ──
  'inv.resources.emptyTitle': 'Aucune ressource trouvée',
  'inv.resources.emptyDesc': 'Importez des ressources depuis la page Ressources pour remplir cette grille.',
  'inv.capabilities.emptyTitle': 'Aucune capacité trouvée',
  'inv.capabilities.emptyDesc': 'Importez des capacités depuis la page Capacités pour remplir cette grille.',
  'inv.outcomes.emptyTitle': 'Aucun résultat trouvé',
  'inv.outcomes.emptyDesc': 'Importez des résultats comportant les colonnes « Motivated By » et « Motivated For » pour remplir cette grille.',
};

export const en: Record<string, string> = {
  // ── shared ──
  'inv.showDetails': 'Show details',
  'inv.noDescription': 'No description available.',
  'inv.addTag': 'Add tag',
  'inv.tagPlaceholder': 'Tag...',
  'inv.noTags': 'No tags',
  'inv.exportPdf': 'Export PDF',

  // ── side-panel labels ──
  'inv.label.type': 'Type',
  'inv.label.function': 'Function',
  'inv.label.description': 'Description',
  'inv.label.nature': 'Nature',
  'inv.label.domainStakeholder': 'Domain / Stakeholder',
  'inv.label.motivatedBy': 'Motivated By',
  'inv.label.motivatedFor': 'Motivated For',
  'inv.label.tags': 'Tags',

  // ── empty states ──
  'inv.resources.emptyTitle': 'No resources found',
  'inv.resources.emptyDesc': 'Upload resources via the Resources page to populate this grid.',
  'inv.capabilities.emptyTitle': 'No capabilities found',
  'inv.capabilities.emptyDesc': 'Upload capabilities via the Capabilities page to populate this grid.',
  'inv.outcomes.emptyTitle': 'No outcomes found',
  'inv.outcomes.emptyDesc': 'Upload outcomes with "Motivated By" and "Motivated For" columns to populate this grid.',
};
